
















































import mixins from 'vue-typed-mixins'
import ValuationData, {
  PropertyValuationStepData,
} from '@/interfaces/valuation/ValuationData'
import { PropertyType } from '@/interfaces/valuation/types/PropertyValuationStep'
import valuationStepMixin from '@/mixins/valuation/valuationStep'

export default mixins(valuationStepMixin).extend({
  data(): { stepData: PropertyValuationStepData } {
    return {
      stepData: {
        propertyType: PropertyType.Flat,
      },
    }
  },
  methods: {
    setType(type: PropertyType): void {
      this.$store.dispatch('valuationProcess/resetValuationData')
      this.stepData.propertyType = type
    },
    isActive(type: PropertyType): boolean {
      return this.stepData.propertyType === type
    },
  },
})
